var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47715 4.47715 0 10 0H22C27.5228 0 32 4.47715 32 10V22C32 27.5228 27.5228 32 22 32H10C4.47715 32 0 27.5228 0 22V10Z",
    fill: "#EFF6FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3337 14.6668C21.3337 17.9955 17.641 21.4622 16.401 22.5328C16.2855 22.6197 16.1449 22.6667 16.0003 22.6667C15.8558 22.6667 15.7152 22.6197 15.5997 22.5328C14.3597 21.4622 10.667 17.9955 10.667 14.6668C10.667 13.2523 11.2289 11.8958 12.2291 10.8956C13.2293 9.8954 14.5858 9.3335 16.0003 9.3335C17.4148 9.3335 18.7714 9.8954 19.7716 10.8956C20.7718 11.8958 21.3337 13.2523 21.3337 14.6668Z",
    stroke: "#155DFC",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 16.6665C17.1046 16.6665 18 15.7711 18 14.6665C18 13.5619 17.1046 12.6665 16 12.6665C14.8954 12.6665 14 13.5619 14 14.6665C14 15.7711 14.8954 16.6665 16 16.6665Z",
    stroke: "#155DFC",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddress);
export default __webpack_public_path__ + "static/media/address.4577e0cc37b83b06402e5b89fd808849.svg";
export { ForwardRef as ReactComponent };